module.exports = __webpack_public_path__ + "img/loading.eaa8b626.svg";